import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ArrowIcon from '@mui/icons-material/ArrowForwardSharp';
import { ClassNameMap } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: theme.typography.caption.fontSize,
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.secondary,
    flexFlow: 'wrap',
    width: '100%'
  },
  pathContainer: {
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    color: 'inherit'
  },
  path: {
    fontSize: 'inherit',
    color: 'inherit'
  },
  icon: {
    margin: theme.spacing(0, 0.25)
  }
}));

type FullPathProps = {
  classes?: ClassNameMap;
  fullPath?: string[];
};

export const FullPath: React.FC<FullPathProps> = ({
  fullPath = [],
  classes: classesOverride
}: FullPathProps) => {
  const classes = useStyles({ classes: classesOverride });

  return (
    <div className={classes.root}>
      {fullPath.map((name, ind) => (
        <span key={name} className={classes.pathContainer}>
          <Typography className={classes.path} component="span">
            {name}
          </Typography>
          {ind < fullPath.length - 1 && (
            <ArrowIcon
              className={classes.icon}
              fontSize="inherit"
              color="inherit"
            />
          )}
        </span>
      ))}
    </div>
  );
};

export default FullPath;
